<div class="row mt-4 g-4">
  @if (labelGroup === LabelGroupDTO.EPC) {
    <div class="col-auto d-flex justify-content-center align-items-center">
      <div class="energy-label energy-label-sm me-2">
        <cfp-energy-label-epc class="d-flex" [labelClass]="'legend'" [size]="'sm'" [energyLabel]="undefined" />
      </div>
      {{ translationKey('energyLabels.legend.calculated') | translate }}
    </div>
    <div class="col-auto d-flex justify-content-center align-items-center">
      <div class="energy-label energy-label-sm me-2">
        <cfp-energy-label-epc
          class="d-flex"
          [labelClass]="'legend'"
          [isRegistered]="true"
          [size]="'sm'"
          [energyLabel]="undefined"
        />
      </div>
      {{ translationKey('energyLabels.legend.registered') | translate }}
    </div>
    @if (hasCalculatedBetterLabels()) {
      <div class="col-auto d-flex justify-content-center align-items-center">
        <div class="energy-label energy-label-sm me-2">
          <cfp-energy-label-epc
            class="d-flex"
            [labelClass]="'legend'"
            [showCalculatedBetter]="true"
            [size]="'sm'"
            [energyLabel]="undefined"
          />
        </div>
        {{ translationKey('energyLabels.legend.calculatedBetter') | translate }}
      </div>
    }
    @if (hasExpiredLabels()) {
      <div class="col-auto d-flex justify-content-center align-items-center">
        <div class="energy-label energy-label-sm me-2">
          <cfp-energy-label-epc
            class="d-flex"
            [labelClass]="'legend'"
            [isRegistered]="true"
            [isRegisteredExpired]="true"
            [size]="'sm'"
            [energyLabel]="undefined"
          />
        </div>
        {{ translationKey('energyLabels.legend.expired') | translate }}
      </div>
    }
    @if (hasAlmostExpiredLabels()) {
      <div class="col-auto d-flex justify-content-center align-items-center">
        <div class="energy-label energy-label-sm me-2">
          <cfp-energy-label-epc
            class="d-flex"
            [labelClass]="'legend'"
            [isRegistered]="true"
            [isRegisteredAlmostExpired]="true"
            [size]="'sm'"
            [energyLabel]="undefined"
          />
        </div>
        {{ translationKey('energyLabels.legend.almostExpired') | translate }}
      </div>
    }
  }
  @if (hasMonument()) {
    <div class="col-auto d-flex justify-content-center align-items-center">
      <cfp-icon class="legend-monument me-2" [icon]="'landmark'" />
      {{ 'building.characteristics.monument' | translate }}
    </div>
  }
  @if (hasManualOverwrittenValue()) {
    <div class="col-auto d-flex justify-content-center align-items-center">
      <cfp-icon [icon]="'pen-circle'" [classes]="'me-2'" />
      {{ translationKey('energyLabels.legend.valueManuallyOverwritten') | translate }}
    </div>
  }
  @if (hasPlan()) {
    <div class="col-auto d-flex justify-content-center align-items-center">
      <cfp-badge [badgeStyle]="'secondary'" [classes]="'me-2'">{{ translationKey('plan') | translate }}</cfp-badge>
      {{ translationKey('energyLabels.legend.plan') | translate }}
    </div>
  }
  @if (hasStatusSellBefore2030()) {
    <div class="col-auto d-flex justify-content-center align-items-center">
      <cfp-badge [badgeStyle]="'primary'" [classes]="'me-2'">{{ translationKey('sell') | translate }}</cfp-badge>
      {{ translationKey('energyLabels.legend.sell') | translate }}
    </div>
  }
</div>
